// extracted by mini-css-extract-plugin
module.exports = {"inputbox":"Outlet_inputbox__1DSzW"};